import { attempt } from "@omni/utils/function.utils";
import { identity } from "lodash-es";

type Props = {
    formattedValues?: Array<string>;
    unitName?: string;
};

export const FeatureValue = ({ formattedValues, unitName }: Props) => {
    if (!formattedValues?.length) return null;

    const value = attempt(
        () => formattedValues.filter(identity).join(", "),
        ""
    );

    const unit = unitName ? ` ${unitName}` : "";

    const feature = `${value}${unit}`;

    if (feature.toLowerCase() === "true") {
        return (
            <span>
                <i className="las la-check"></i>
            </span>
        );
    } else if (feature.toLowerCase() === "false") {
        return (
            <span>
                <i className="las la-times"></i>
            </span>
        );
    } else {
        return feature;
    }
};
